import {  ProductListItemVM } from "../../../../models/product-v3";

export class ProductV3Adapter {
  static toListVM(item: ProductListItemVM): ProductListItemVM {
    console.log('item v3 adapter', item);
    return {
      id: item.id,
      name: item.name,
      sku: item.productRefId,
      categoryName: item.category?.name,
      status: item.status,
      imageUrl: undefined, // hasta que V3 tenga imágenes
      isBundle: false,
      canEdit: true,
      canManageBundle: false,
    };
  }
}
